import { Injectable } from '@angular/core';
import { Reducer } from 'redux';
import { NgRedux } from '@angular-redux/store';
import { Field } from '../../../../models/field';
import { IAppState } from '../../../../../store/model';
import { StoreReducers } from '../../../../../store/root.reducer';
import { StoreKeys } from '../../../../models/store-keys';
import { WkfCfgFieldConstant, wkfCfgFieldReducer, WkfFieldState } from '../../reducer/wkf/wkf-cfg-field.reducer';
import { AbstractCfgFieldAction } from '../abstract-cfg-field.action';

@Injectable({
  providedIn: 'root'
})
export class WkfCfgFieldAction extends AbstractCfgFieldAction {

  constructor(
    ngRedux: NgRedux<IAppState>
  ) {
    super(ngRedux);
  }

  protected getCfgFieldStorePath(): string[] {
    return [StoreReducers.DYNAMIC_SUB_STORES, StoreKeys.WKF_CFG_FIELD];
  }

  protected getCfgFieldReducer(): Reducer<WkfFieldState> {
    return wkfCfgFieldReducer;
  }

  public loadStarted(): void {
    this._dispatchType(WkfCfgFieldConstant.ADD_MULTIPLE_CFG_FIELD_START);
  }

  public loadSucceeded(mapField: {[key: string]: Field}): void {
    this._dispatchSuccess(WkfCfgFieldConstant.ADD_MULTIPLE_CFG_FIELD_SUCCEEDED, mapField);
  }

  public loadFailed(error: any) {
    this._dispatchFail(WkfCfgFieldConstant.ADD_MULTIPLE_CFG_FIELD_FAILED, error);
  }

  public removeAllStarted(): void {
    this._dispatchType(WkfCfgFieldConstant.REMOVE_ALL_CFG_FIELD_START);
  }

  public removeAllSucceeded(): void {
    this._dispatchType(WkfCfgFieldConstant.REMOVE_ALL_CFG_FIELD_SUCCEEDED);
  }

  public removeAllFailed(error: any): void {
    this._dispatchFail(WkfCfgFieldConstant.REMOVE_ALL_CFG_FIELD_FAILED, error);
  }

}
